import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export const RESULTS_DISCLAIMER_LONG =
  "Results vary: Stag Vault provides AI-powered tools, prompts and structured workflows—not guaranteed income. Your results will depend on your skills, experience, effort, chosen market, pricing, customer demand and how effectively you implement the material. Examples and suggested prices are provided for educational and illustrative purposes.";

export const RESULTS_DISCLAIMER_SHORT = "Stag Vault provides tools and workflows, not guaranteed income. Results vary.";

export function ResultsDisclaimer({ variant = "long", className = "", testId = "results-disclaimer" }) {
  if (variant === "short") {
    return (
      <p className={`text-sm leading-relaxed text-zinc-400 ${className}`} data-testid={`${testId}-short`}>
        {RESULTS_DISCLAIMER_SHORT}{" "}
        <Link to="/results-disclaimer" className="underline decoration-zinc-600 underline-offset-4 hover:text-purple-300">Full disclaimer</Link>
      </p>
    );
  }
  return (
    <aside className={`flex gap-3 border border-zinc-800 bg-[#0a070d] p-4 text-sm leading-relaxed text-zinc-300 sm:p-5 ${className}`} data-testid={testId} aria-label="Results disclaimer">
      <Info size={18} className="mt-0.5 shrink-0 text-purple-300" aria-hidden="true" />
      <p>
        {RESULTS_DISCLAIMER_LONG}{" "}
        <Link to="/results-disclaimer" className="text-purple-300 underline decoration-purple-500/50 underline-offset-4 hover:text-purple-200">Read the full results disclaimer</Link>
      </p>
    </aside>
  );
}
